import React from 'react';
import ContentLoader from 'react-content-loader'

export const GroupsSkeleton = (): JSX.Element => (
    <div className='w-[500px]'>
      <ContentLoader
        speed={2}
        width={500}
        height={350}
        viewBox='0 0 500 350'
        backgroundColor='#f3f3f3'
        foregroundColor='#ecebeb'
      >
        <rect x='5' y='0' rx='5' ry='5' width='120' height='25' />
        <rect x='5' y='30' rx='5' ry='5' width='160' height='15' />
        <rect x='215' y='0' rx='15' ry='15' width='150' height='40' />
        <rect x='5' y='70' rx='15' ry='15' width='180' height='180' />
        <rect x='5' y='260' rx='5' ry='5' width='95' height='25' />
        <rect x='5' y='290' rx='5' ry='5' width='115' height='20' />
        <rect x='5' y='315' rx='5' ry='5' width='120' height='15' />
        <rect x='5' y='335' rx='5' ry='5' width='125' height='15' />
        <rect x='210' y='70' rx='15' ry='15' width='180' height='180' />
        <rect x='210' y='260' rx='5' ry='5' width='95' height='25' />
        <rect x='210' y='290' rx='5' ry='5' width='115' height='20' />
        <rect x='210' y='315' rx='5' ry='5' width='120' height='15' />
        <rect x='210' y='335' rx='5' ry='5' width='125' height='15' />
      </ContentLoader>
    </div>
  );
